/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect, createContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import * as actions from 'src/setup/redux/global/Actions';
import * as actionsModal from 'src/setup/redux/modal/Actions';

import Publisher from './components/Publisher';
import Receiver from './components/Receiver';

import ModalItem from './components/ChiTietModal';

export const QosOption = createContext([]);

const HardwareDebugPage = () => {
  const dispatch = useDispatch();
  const client = useSelector((state) => state.global.client);
  const connectStatus = useSelector((state) => state.global.connectStatus);
  const modalVisible = useSelector((state) => state.modal.modalVisible);
  const subscription = useSelector((state) => state.global.subscription);

  //const [client, setClient] = useState(null);
  // publish message
  const mqttPublish = (context) => {
    if (client) {
      const {topic, qos, payload} = context;
      client.publish(topic, payload, {qos}, (error) => {
        if (error) {
          console.log('Publish error: ', error);
        }
      });
    }
  };

  return (
    <>
      <div className='card card-xl-stretch mb-xl-9'>
        <div className='px-3 py-3 border-bottom border-secondary border-bottom-solid d-flex align-items-center justify-content-between'>
          <h3 className='card-title fw-bold text-header-td fs-4 mb-0'>{'Debug'}</h3>
          <div className='card-toolbar'>
            {connectStatus != 'Kết nối' ? (
              <button
                className='btn btn-danger py-2 me-2'
                onClick={() => {
                  console.log('ngatketnoi');

                  dispatch(actions.mqttDisconnect());
                }}
              >
                <span>
                  <i className='fas fa-times me-2'></i>
                  <span className=''>Ngắt kết nối</span>
                </span>
              </button>
            ) : (
              <button
                className='btn btn-primary py-2 me-2'
                onClick={() => {
                  console.log('ketnoi');
                  dispatch(actions.listenNotifications());
                }}
              >
                <span>
                  <i className='fas fa-check me-2'></i>
                  <span className=''>{connectStatus}</span>
                </span>
              </button>
            )}
          </div>
        </div>
        <div className='card-body px-0   py-3 bg-light'>
          <div className='row'>
            <div className='col-xl-4'>
              <div className='card shadow-sm  h-xl-100'>
                <div className='card-header'>
                  <h3 className='card-title align-items-start flex-column m-0'>
                    <span className='card-label fw-bold text-gray-900'>Subscription</span>
                  </h3>
                  <div className='card-toolbar m-0'>
                    <button
                      className='btn btn-sm  btn-primary py-2 me-2'
                      onClick={() => {
                        dispatch(actionsModal.setModalVisible(true));
                      }}
                    >
                      <span>
                        <i className='fas fa-plus me-2'></i>
                        <span className=''>New Sub</span>
                      </span>
                    </button>
                  </div>
                </div>
                <div className='card-body p-0'>
                  {subscription.map((i, index) => (
                    <div className='border border-dashed border-gray-300 rounded p-3 m-1' key={index}>
                      <div className='d-flex flex-stack'>
                        <span className='text-gray-600 fw-bold'>{i.topic}</span>
                        <div>
                          <span className='text-gray-500 me-2'>QoS: {i.qos}</span>
                          <a
                            className='btn btn-sm  btn-icon btn-bg-light btn-active-color-danger btn-sm'
                            data-toggle='m-tooltip'
                            title='Xoá'
                            onClick={() => {
                              dispatch(actions.unSub(i));
                            }}
                          >
                            <i className='fa fa-trash'></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className='col-xl-8'>
              <div className='card-flush h-xl-100'>
                <div className='card shadow-sm card-flush h-md-60 mb-5'>
                  <Receiver />
                </div>
                <div className='card card-flush h-md-40'>
                  <Publisher publish={mqttPublish} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalVisible ? <ModalItem /> : <></>}
    </>
  );
};

export default HardwareDebugPage;
